import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormikField } from "@air/formik-field";
import { Input } from "@air/primitive-input";
import { useField } from "formik";
import { EXPORT_IMAGES_SUFFIX_INPUT } from "~/constants/testIDs";
export const PLACEHOLDER_IMAGE_BASE_NAME = "IMAGE-O1";
export const ImageSuffixFormField = (param)=>{
    let { setIsEditing } = param;
    const [{ value: suffix }] = useField("suffix");
    const [{ value: format }] = useField("ext");
    const [{ value: fileName }] = useField("fileName");
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex grow flex-col",
        children: [
            /*#__PURE__*/ _jsx(FormikField, {
                label: "Suffix",
                name: "suffix",
                id: "suffix",
                component: /*#__PURE__*/ _jsx(Input, {
                    onFocus: ()=>setIsEditing(true),
                    onBlur: ()=>setIsEditing(false),
                    className: "w-full",
                    size: "extra-large",
                    type: "text",
                    "data-testid": EXPORT_IMAGES_SUFFIX_INPUT
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-2 break-all text-12 text-grey-10",
                children: [
                    "Preview:\xa0",
                    fileName,
                    suffix,
                    ".",
                    format
                ]
            })
        ]
    });
};
